<ng-container *ngIf="order; else Spinner">
  <div class="container flex h-full flex-col">
    <!-- header -->
    <div class="header flex w-full flex-row items-center justify-between">
      <div class="title flex flex-row items-center">
        <ion-icon src="../../../assets/icon/attention-icon.svg"></ion-icon>
        <h1>REPETIR PEDIDO</h1>
      </div>

      <ion-button fill="clear" class="close-button" (click)="onCloseModal()">
        <ion-icon src="../../../assets/icon/cross.svg"></ion-icon>
      </ion-button>
    </div>

    <!-- header -->

    <hr />

    <!-- contenido -->
    <h1 class="body-title">Vas a repetir tu pedido #{{ order_number }}</h1>
    <p class="body-text">
      Al repetir un pedido, se vuelven a añadir a tu carrito los mismo artículos que elegiste la primera vez. Por favor,
      ten en cuenta que algunos artículos pueden haber cambiado de precio.
    </p>
    <p class="body-text">
      En caso de que alguno de los artículos se encuentre fuera de stock o ya no esté a la venta, deberás sutituirlo o
      eliminarlo.
    </p>
    <p class="body-text">Si lo deseas, también podrás editar los datos de la dirección de envío, facturación, etc.</p>
    <!-- contenido -->

    <hr />

    <!-- actions -->

    <div class="flex justify-end">
      <div class="flex flex-row justify-end gap-2">
        <ion-button color="medium-dark" fill="outline" (click)="onCloseModal()">Cancelar</ion-button>
        <ion-button class="flex-grow" (click)="onRepeatOrder()">Aceptar y continuar</ion-button>
      </div>
    </div>

    <!-- actions -->
  </div>
</ng-container>

<!-- Template Section -->
<ng-template #Spinner>
  <ion-content style="margin: auto">
    <ion-row class="ion-justify-content-center ion-align-items-center" style="height: 25%">
      <ion-spinner></ion-spinner>
    </ion-row>
  </ion-content>
</ng-template>
